import classNames from "classnames";
import React, { HTMLAttributes, ReactNode } from "react";
import DetailRow from "./DetailRow";
import Styles from "./Details.module.scss";
import DetailSection from "./Section";

const DetailsRoot = React.forwardRef((
    args: HTMLAttributes<HTMLDivElement>,
    ref: React.ForwardedRef<HTMLDivElement>,
): ReactNode => {
    const {
        children,
        className,
        ...rest
    } = args;
    return (
        <div className={classNames(className, Styles.details)} {...rest} ref={ref}>
            {children}
        </div>
    );
});
DetailsRoot.defaultProps = {
    className: undefined,
};

type DetailSectionWithTypes = ((
    props: HTMLAttributes<HTMLDivElement> & { ref?: React.ForwardedRef<HTMLUListElement> }
) => ReturnType<typeof DetailsRoot>) & {
    Section: typeof DetailSection;
    Row: typeof DetailRow;
}

const Details = DetailsRoot as unknown as DetailSectionWithTypes;
Details.Row = DetailRow;
Details.Section = DetailSection;

export default Details;
